<template>
    <div class="contact-card block">
        <div class="contact-card__head">
            <div class="contact-card__title h3">
                <span>{{ getTitle }}</span>
                <span class="contact-card__caption">{{ item.Area }}</span>
            </div>
            <div class="contact-card__type h3">{{getContactType}}</div>
        </div>
        <div class="contact-card__body">
            <div class="contact-card__row _fill">
                <div class="contact-card__line">
                    <div class="contact-card__value">{{ item.Address }}</div>
                </div>
            </div>
            <div class="contact-card__row">
                <div class="contact-card__line">
                    <div class="contact-card__label">Режим работы:</div>
                    <div class="contact-card__value">{{ item.WorkingTime }}</div>
                </div>
                <div class="contact-card__line">
                    <div class="contact-card__label">Колл-центр:</div>
                    <div class="contact-card__value">{{ item.WorkingTimeCallCenter }}</div>
                </div>
            </div>
            <div class="contact-card__row">
                <div class="contact-card__line">
                    <div class="contact-card__label">ЦОК:</div>
                    <div class="contact-card__value">
                        {{ item.ContactsCOK }}
                        <a :href="`mailto:${item.Email}`" calss="link link--main">{{ item.Email }}</a>
                    </div>
                </div>
                <div class="contact-card__line">
                    <div class="contact-card__label">Колл-центр:</div>
                    <div class="contact-card__value">
                        {{ item.ContactsCallCenter }}
                        <a :href="`mailto:${item.EmailCallCenter}`" calss="link link--main">{{ item.EmailCallCenter }}</a>
                    </div>
                </div>
            </div>
            <div class="contact-card__row">
                <div class="contact-card__line">
                    <div class="contact-card__label">Расположение на картах:</div>
                    <div class="contact-card__value">
                        <a :href="item.Location" target="_blank" rel="noopener noreferrer">
                            <img src="/images/map-icons/yandex_map.jpg" alt="яндекс">
                        </a>
                        <a :href="item.LocationGoogleMaps" target="_blank" rel="noopener noreferrer">
                            <img src="/images/map-icons/google_map.jpg" alt="google map">
                        </a>
                        <a :href="item.Location2Gis" target="_blank" rel="noopener noreferrer">
                            <img src="/images/map-icons/gis2.jpg" alt="2Gis">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { getNameCategoryTypeCOK } from '../../../wwwroot/app/epp.utils';
    export default {
        props: {
            item: Object
        },
        computed: {
            getContactType: function () {
                return getNameCategoryTypeCOK(this.item.CategoryType)
            },
            getTitle: function () {
                if (this.item.Title) {
                    return this.item.Title
                }
                return "Центр обслуживания клиентов"
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/app/FooterContactInfo/ContactCardItemV2.vue